import script from "./AdminChangeLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminChangeLogs.vue?vue&type=script&setup=true&lang=js"

import "./AdminChangeLogs.vue?vue&type=style&index=0&id=31955ad5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31955ad5"]])

export default __exports__